<template>
  <div class="info-question">
    <div class="name-question">
      <div v-if="editor.textAnswer" class="edit-name">
        <input :value="question.text" @input="changeQuestion(question.id, 'text',$event, quiz)" @change="changeQuestion(question.id, 'text',$event, quiz)" @focusout="setEditorName" />
      </div>
      <div v-else class="name">
        <span class="text">{{ question.text }}</span>
        <select class="choose-kind" @change="changeQuestion(question.id, 'kind', $event, quiz)" >
          <option value="1">Một đáp án</option>
          <option value="2">Nhiều đáp án</option>
        </select>
        <div class="trash-question" @click="removeQuestion(question.id, quiz)">
            <TrashIcon />
        </div>
        <div class="edit-icon" @click="changeNameAnswer">
          <EditIcon />
        </div>
      </div>
    </div>
    <div class="description-question">
      <div v-if="editor.description" class="edit-description">
        <input :value="question.description" @input="changeQuestion(question.id, 'description', $event, quiz)" @change="changeQuestion(question.id, 'description', $event, quiz)" @focusout="setEditorDes" />
      </div>
      <div v-else class="description">
        <span>{{question.description}}</span>
        <div class="edit-icon" @click="changeDesAnswer">
          <EditIcon />
        </div>
      </div>
      
    </div>
    <div class="answer" v-for="(answer,index) in question.options" v-bind:key="index">
        <div v-if="question.kind > 1" class="multi-choose-ans" v-bind:class="question.answers.includes(answer.id) ? 'checked-multi-ans' : ''" @click="chooseAnswer(question,answer.id, quiz)">
          <Correct />
        </div>
        <div v-else class="radio" v-bind:class="question.answers.includes(answer.id) ? 'checked-ans' : ''" @click="chooseAnswer(question,answer.id,quiz)">
            <input type="radio" value="label" name="name">
        </div>
        <div class="val-answer">
          <input type="text" :value="answer.text" @input="changeAnswer(question.id, answer.id, $event, quiz)" @change="changeAnswer(question.id, answer.id, $event, quiz)" />
          <div v-if="answer.media != null" class="img-ans">
            <img :src="answer.media.value.src" />
            <div @click="removeMedia(question.id,answer.id,quiz)" class="remove-media">
              <CloseIcon />
            </div>
          </div>
        </div>
        <div class="media-icon" @click="addMediaAnswer(question.id,answer.id,quiz)">
          <MediaIcon />
        </div>
        <div class="trash-icon" @click="removeAnswer(question.id,answer.id, quiz)">
            <TrashIcon />
        </div>
        
    </div>
    <div class="add-answer" @click="addAnswer(question.id,quiz)">
      <AddIcon />
      Thêm đáp án
    </div>
  </div>
</template>

<script>
import TrashIcon from '../../ui/icons/svgs/icons/TrashIcon'
import Correct from '../../ui/icons/svgs/icons/Correct'
import EditIcon from '../../ui/icons/svgs/icons/EditIcon'
import CloseIcon from '../../ui/icons/svgs/icons/CloseIcon'
import MediaIcon from '../../ui/icons/svgs/icons/MediaIcon'
import AddIcon from '../../ui/icons/svgs/icons/AddIcon'

export default {
  name: "EditorQuestion",
  props: ['question', 'quiz'],
  data: function(){
    return{
      editor: {
        textAnswer: false,
        description: false
      }
    }
  },
  components: {
    TrashIcon,
    Correct,
    EditIcon,
    CloseIcon,
    MediaIcon,
    AddIcon
  },
  methods: {
    removeAnswer(question_id,answer_id, quiz){
      quiz.action('removeOption',question_id,answer_id)
    },
    chooseAnswer(question, answer_id, quiz){
      quiz.action('addAnswer',question.id,answer_id,question.kind)
    },
    changeAnswer(question_id, answer_id, $event, quiz){
      quiz.action('changeOption', question_id,answer_id,'text',$event.target.value);
    },
    changeQuestion(question_id, file_name, $event, quiz){
      quiz.action('changeQuestion', question_id, file_name, $event.target.value)
    },
    changeNameAnswer(){
      this.editor.textAnswer = true
    },
    setEditorName(){
      this.editor.textAnswer = false
    },
    changeDesAnswer(){
      this.editor.description = true
    },
    setEditorDes(){
      this.editor.description = false
    },
    removeMedia(question_id,answer_id,quiz){
      quiz.action('changeOption',question_id,answer_id,'media',null)
    },
    addMediaAnswer(question_id,answer_id,quiz){
      quiz.action('selectOptionMedia',question_id,answer_id)
    },
    addAnswer(question_id,quiz){
      quiz.action('addOption', question_id);
    },
    removeQuestion(question_id,quiz){
      quiz.action('removeQuestion', question_id);
    },
    chooseKind($event){
      // debugger
    }
  }
};
</script>